  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-card__swiper').forEach(function (swiperEl, index) {
      const uniqueId = 'swiper-' + index;
      swiperEl.classList.add(uniqueId);

      const paginationEl = swiperEl.querySelector('.swiper-pagination');
      const nextEl = swiperEl.querySelector('.swiper-button-next');
      const prevEl = swiperEl.querySelector('.swiper-button-prev');

      new Swiper('.' + uniqueId, {
        loop: true,
        slidesPerView: 1,
        lazy: true,
        spaceBetween: 0,
        watchSlidesVisibility: true,
        pagination: {
          el: paginationEl,
          clickable: true
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl
        }
      });
    });
  });